import { FC } from "react";
import {
  Avatar,
  Chip,
  createStyles,
  Grid,
  makeStyles,
} from "@material-ui/core";
import {
  NewReleases as NewReleasesIcon,
  Whatshot as WhatshotIcon,
} from "@material-ui/icons";
import { includes } from "lodash";

import { InventoryListing } from "services/inventory/types";
import { LISTING_KIND } from "services/listings/constants";
import { useListingInfos } from "services/listings/hooks";
import { Theme } from "theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    systemTag: {
      color: theme.custom.palette.black.main,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.background.default,
      fontWeight: "bold",
      fontSize: "0.7rem",
    },
    smallIcon: {
      color: theme.custom.palette.black.main,
      height: "15px",
      width: "15px",
    },
  }),
);

interface SystemTagsProps {
  listing: InventoryListing;
}

const SystemTags: FC<SystemTagsProps> = ({ listing }) => {
  const classes = useStyles();
  const [isNewListing, isActiveOwner] = useListingInfos(
    listing.published_date,
    listing.owner_last_active_date,
  );

  const isAcceptingFinalOffers = listing.state === "accepting_final_offers";

  return (
    <Grid container spacing={1}>
      {isAcceptingFinalOffers ? (
        <Grid item>
          <Chip
            label="Accepting Final Offers"
            icon={<NewReleasesIcon className={classes.smallIcon} />}
            className={classes.systemTag}
          />
        </Grid>
      ) : (
        <>
          {listing?.is_featured && (
            <Grid item>
              <Chip
                avatar={
                  <Avatar
                    alt="Featured Listing"
                    src={`${
                      import.meta.env.REACT_APP_STATIC_URL
                    }/images/Diamond.png`}
                    style={{ height: "15px", width: "15px" }}
                  />
                }
                label="Featured"
                className={classes.systemTag}
              />
            </Grid>
          )}
          {isNewListing && includes(LISTING_KIND, listing.kind) && (
            <Grid item>
              <Chip
                label="New"
                icon={<NewReleasesIcon className={classes.smallIcon} />}
                className={classes.systemTag}
              />
            </Grid>
          )}
          {isActiveOwner && (
            <Grid item>
              <Chip
                label="Active Owner"
                icon={<WhatshotIcon className={classes.smallIcon} />}
                className={classes.systemTag}
              />
            </Grid>
          )}
          {listing.kind === "auction" && (
            <Grid item>
              <Chip
                label="Auction"
                icon={<NewReleasesIcon className={classes.smallIcon} />}
                className={classes.systemTag}
              />
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default SystemTags;
